export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-4-f4d3aef82af7f042392427ef4f76784e.png";